import type { AppRouter } from "@teamz/api/trpc";
import type { inferRouterOutputs } from "@trpc/server";

import { createTRPCContext } from "@trpc/tanstack-react-query";

export const { TRPCProvider, useTRPC, useTRPCClient } = createTRPCContext<AppRouter>();

export type RouterOutputs = inferRouterOutputs<AppRouter>;
